/** Language code of the per-language screenshot files (/images/screens/<set>/<name>.<lang>.webp). */
export const SCREEN_LANGS = ['en', 'de', 'pt-PT', 'pt-BR', 'pl'] as const;

export function screenLang(language: string | undefined): string {
  const lng = language ?? 'en';
  if ((SCREEN_LANGS as readonly string[]).includes(lng)) return lng;
  const base = lng.split('-')[0];
  if (base === 'pt') return 'pt-PT';
  return (SCREEN_LANGS as readonly string[]).includes(base) ? base : 'en';
}
